import React, { useState } from "react";

type TProjectContext = {
  isAddModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isShowSpecialPriceModal: boolean;
  setIsShowSpecialPriceModal: React.Dispatch<React.SetStateAction<boolean>>;
  isUpdateModalOpen: {
    isOpen: boolean;
    id: string;
  };
  setIsUpdateModalOpen: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      id: string;
    }>
  >;
};

const projectContext = React.createContext<TProjectContext>(
  {} as TProjectContext,
);

// eslint-disable-next-line react-refresh/only-export-components
export const useProjectContext = (): TProjectContext => {
  return React.useContext(projectContext);
};

export const ProjectContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [isAddModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isShowSpecialPriceModal, setIsShowSpecialPriceModal] =
    useState<boolean>(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState({
    isOpen: false,
    id: "",
  });

  return (
    <projectContext.Provider
      value={{
        isAddModalOpen,
        setIsModalOpen,
        isShowSpecialPriceModal,
        setIsShowSpecialPriceModal,
        isUpdateModalOpen,
        setIsUpdateModalOpen,
      }}
    >
      {children}
    </projectContext.Provider>
  );
};
